import { render, staticRenderFns } from "./DetailSaleInvoice.vue?vue&type=template&id=08ad4c8a"
import script from "./DetailSaleInvoice.vue?vue&type=script&lang=js"
export * from "./DetailSaleInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports